export default __webpack_public_path__ + "static/profile-pig-64fe192700c4bd2bfe5648bcf70266b5.jpg";